import { ApiMessageCodes } from "@/domains/shared/services/apiMessageCodes";
import { SUBSCRIPTION_TRANSLATIONS } from "@/domains/subscription/constants";
import { getTranslation } from "@mivo/i18n";

/** Canonical pt-BR fallback string still returned as API `detail` (coexistence). Not used for control flow. */
export const TRIAL_EXPIRED_DETAIL = SUBSCRIPTION_TRANSLATIONS.trialExpiredDetail["pt-BR"];

export const TRIAL_EXPIRED_REASON = ApiMessageCodes.trialExpired;

export const TRIAL_EXPIRED_STORAGE_KEY = "mivo_trial_expired";

export function getTrialExpiredMessage(): string {
    return getTranslation(SUBSCRIPTION_TRANSLATIONS.trialExpiredDetail);
}

export function consumeTrialExpired(): boolean {
    const flagged = sessionStorage.getItem(TRIAL_EXPIRED_STORAGE_KEY) === "1";

    if (flagged) {
        sessionStorage.removeItem(TRIAL_EXPIRED_STORAGE_KEY);
    }

    return flagged;
}

/** @deprecated Prefer {@link isTrialExpiredResponse} — Portuguese detail equality is not control-flow (BR-07). */
export function isTrialExpiredDetail(detail: unknown): boolean {
    return detail === TRIAL_EXPIRED_DETAIL;
}

/** Detect trial-expired gate from `code` / `reason` (FR-05, AC-04). */
export function isTrialExpiredResponse(data: unknown): boolean {
    if (!data || typeof data !== "object") {
        return false;
    }

    const payload = data as { code?: unknown; reason?: unknown };
    return payload.code === TRIAL_EXPIRED_REASON || payload.reason === TRIAL_EXPIRED_REASON;
}
